import { recognitionDateForPointInTime } from '@/lib/recognitionDate';
import { flag, isoDate, oneOf } from '@/hooks/useUrlState';

export type CalendarView = 'month' | 'week';

/**
 * The /nights calendar, in this order (see README "List pages, URL state"). `date` is the day the
 * calendar is positioned on; its default is today's recognition day, so Today drops the key.
 */
export const nightCalendarUrlSchema = {
  date: isoDate(() => recognitionDateForPointInTime()),
  view: oneOf<CalendarView, CalendarView>({ month: true, week: true }, 'month'),
  inactive: flag(),
};
